import { computed, ComputedRef } from "vue";
import type { IBuilderEstimatorFormData } from "@/types/BuilderEstimatorFormData";
import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";

export function getAllSummaryItemsFromForm(
  formData: IBuilderEstimatorFormData
) {
  const summaryItems = computed(() => [
    {
      title: "FLOOR PLAN",
      value: formData[BuilderEstimatorSteps.SELECT_DESIGN]?.houseDesign?.name,
      price:
        formData[BuilderEstimatorSteps.SELECT_DESIGN]?.houseDesign?.basePrice,
      imageUrl:
        formData[BuilderEstimatorSteps.SELECT_DESIGN]?.houseDesign
          ?.floorplans?.[0]?.url,
    },
    {
      title: "FACADE",
      value: formData[BuilderEstimatorSteps.SELECT_FACADE]?.facade?.name,
      price: formData[BuilderEstimatorSteps.SELECT_FACADE]?.facade?.price,
      imageUrl: formData[BuilderEstimatorSteps.SELECT_FACADE]?.facade?.url,
    },
    {
      title: "INCLUSIONS",
      value:
        formData[BuilderEstimatorSteps.SELECT_INCLUSIONS]?.inclusionPack
          ?.inclusionId?.type,
      price:
        formData[BuilderEstimatorSteps.SELECT_INCLUSIONS]?.inclusionPack?.price,
      imageUrl: null,
    },
    {
      title: "EXTERNAL COLOUR",
      value:
        formData[BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]
          ?.externalColorScheme?.name,
      price:
        formData[BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]
          ?.externalColorScheme?.price,
      imageUrl:
        formData[BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]
          ?.externalColorScheme?.imagesUrls[0],
    },
    {
      title: "INTERNAL COLOUR",
      value:
        formData[BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]
          ?.internalColorScheme?.name,
      price:
        formData[BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]
          ?.internalColorScheme?.price,
      imageUrl:
        formData[BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]
          ?.internalColorScheme?.imagesUrls[0],
    },
  ]);

  const optionalUpgradeItems = computed(() => {
    const upgrades =
      formData[BuilderEstimatorSteps.OPTIONAL_UPGRADES]?.optionalUpgrades;

    if (!upgrades?.length) {
      return [
        {
          title: "PROMOTIONS / OPTIONAL UPGRADES",
          value: null,
          price: null,
          imageUrl: null,
        },
      ];
    }

    return upgrades.map((upgrade) => ({
      id: upgrade._id,
      title: "PROMOTIONS / OPTIONAL UPGRADES",
      value: upgrade.name,
      price: upgrade.price,
      url: upgrade.url,
    }));
  });

  const allSummaryItems = computed(() => [
    ...summaryItems.value,
    ...optionalUpgradeItems.value,
  ]);

  return {
    allSummaryItems,
  };
}
